import React, { FC } from 'react';
import { ReactComponent as NothingSuppliedIcon } from '@blink/assets/src/icons/nothingSupplied.svg';

import { cn } from '@/shared/lib/tailwind-merge';

interface EmptyBannerProps {
    customTitle?: string;
    customSubtitle?: string;
    icon?: React.ElementType;
    className?: string;
    component?: React.ReactNode | null;
}

export const EmptyBanner: FC<EmptyBannerProps> = ({
    customTitle,
    customSubtitle,
    icon: Icon,
    className,
    component = null,
}) => {
    return (
        <div
            className={cn(
                'flex flex-col items-center justify-center p-8 border border-muted bg-background shadow-sm min-h-[230px]',
                className,
            )}
        >
            {Icon ? (
                <Icon className='w-12 h-12 text-primary' />
            ) : (
                <NothingSuppliedIcon className='w-12 h-12 text-primary' />
            )}
            <h2 className='mt-3 text-lg font-semibold text-primary'>
                {customTitle ?? 'Nothing supplied yet'}
            </h2>
            <p className='mt-3 max-w-lg text-center text-secondary font-normal'>
                {customSubtitle ?? 'Nothing supplied yet. Start supplying by choosing an asset.'}
            </p>
            {component && <div className='mt-4'>{component}</div>}
        </div>
    );
};
